import * as clone from 'clone';
import defaultTheme from './themedefault';

const theme = clone(defaultTheme, undefined, undefined, undefined, undefined);
theme.palette.primary = ['#f00'];
theme.palette.secondary = ['#0f0'];
export default theme;



// WEBPACK FOOTER //
// ./src/config/themes/theme2.ts